import { Component, Input } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { GetSelectProjectParams, ProjectItem } from '@app/services/project.service';

@Component({
    selector: 'tt-select-project-view',
    templateUrl: './select-project-view.component.html',
    styleUrls: ['./select-project-view.component.css'],
})
export class SelectProjectViewComponent {
    @Input()
    public params: GetSelectProjectParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as GetSelectProjectParams;
    }

    public onSubmit(event: ProjectItem) {
        this.state.back();
    }
}
